import React, { useState } from 'react';
import { FaDownload } from 'react-icons/fa6';

export default function DownloadProfile(props) {
    return null;
    return (
        <div style={{ textAlign: 'right' }}>
            <img src="/wp-content/plugins/ace-carnegie-institution-charts/frontend/src/images/icon-download.svg"
                alt="Download Icon" className="me-2" style={{ width: '20px', height: '20px' }} />
            <a href='#'>Download CSV</a>
        </div>
    );
}